/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkspaceResponse } from './WorkspaceResponse';
import {
    WorkspaceResponseFromJSON,
    WorkspaceResponseFromJSONTyped,
    WorkspaceResponseToJSON,
} from './WorkspaceResponse';

/**
 * 
 * @export
 * @interface WorkspaceResponseListResponse
 */
export interface WorkspaceResponseListResponse {
    /**
     * 
     * @type {Array<WorkspaceResponse>}
     * @memberof WorkspaceResponseListResponse
     */
    items: Array<WorkspaceResponse>;
}

/**
 * Check if a given object implements the WorkspaceResponseListResponse interface.
 */
export function instanceOfWorkspaceResponseListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function WorkspaceResponseListResponseFromJSON(json: any): WorkspaceResponseListResponse {
    return WorkspaceResponseListResponseFromJSONTyped(json, false);
}

export function WorkspaceResponseListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceResponseListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WorkspaceResponseFromJSON)),
    };
}

export function WorkspaceResponseListResponseToJSON(value?: WorkspaceResponseListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(WorkspaceResponseToJSON)),
    };
}

